import {
  FaPenNib,
  FaIdBadge,
  FaPaintBrush,
  FaFilm,
  FaTv,
  FaRobot,
  FaBookOpen,
  FaCamera,
  FaUsers,
  FaMobileAlt,
  FaMicrophoneAlt,
  FaLightbulb,
  FaDraftingCompass,
  FaRulerCombined,
  FaCommentDots,
  FaMapMarkedAlt,
  FaSmile,
  FaBullhorn,
  FaProjectDiagram,
  FaMusic,
  FaMagic,
  FaHeadphones,
  FaVideo,
  FaVolumeUp,
  FaEdit,
} from "react-icons/fa";

import "../styles/banner.css";

const cardsData = [
  {
    title: "1. Sáng tạo nội dung",
    icon: FaPaintBrush,
    items: [
      {
        icon: FaPenNib,
        text: "Sáng tạo nội dung hấp dẫn cho bài viết, blog du lịch",
      },
      { icon: FaIdBadge, text: "Tối ưu nội dung theo xu hướng và thị trường" },
    ],
  },
  {
    title: "2. Chụp ảnh",
    icon: FaCamera,
    items: [
      { icon: FaMobileAlt, text: "Kỹ thuật chụp ảnh đẹp bằng smartphone" },
      { icon: FaLightbulb, text: "Tự động điều chỉnh ánh sáng và màu sắc" },
      { icon: FaRobot, text: "Nâng cao chất lượng hình ảnh bằng AI" },
    ],
  },
  {
    title: "3. Chỉnh sửa ảnh",
    icon: FaEdit,
    items: [
      { icon: FaMagic, text: "Cải thiện độ sắc nét và chi tiết ảnh" },
      {
        icon: FaDraftingCompass,
        text: "Tự động cân chỉnh ánh sáng và màu sắc",
      },
      {
        icon: FaRulerCombined,
        text: "Tối ưu chất lượng và độ cân đối hình ảnh",
      },
    ],
  },
  {
    title: "4. Thiết kế quảng cáo",
    icon: FaTv,
    items: [
      { icon: FaCommentDots, text: "Thiết kế quảng cáo du lịch bắt mắt" },
      {
        icon: FaSmile,
        text: "Lựa chọn phong cách phù hợp với đối tượng khách hàng",
      },
      { icon: FaBullhorn, text: "Tạo mẫu quảng cáo nhanh chóng với Canva" },
    ],
  },
  {
    title: "5. Quay video",
    icon: FaVideo,
    items: [
      { icon: FaMobileAlt, text: "Quay video chất lượng cao bằng smartphone" },
      { icon: FaCamera, text: "Tự động điều chỉnh ánh sáng và góc quay" },
      { icon: FaMapMarkedAlt, text: "Tạo thước phim chuyên nghiệp, hấp dẫn" },
    ],
  },
  {
    title: "6. Dựng video",
    icon: FaUsers,
    items: [
      { icon: FaLightbulb, text: "Dựng video dễ dàng với phần mềm như Capcut" },
      { icon: FaBookOpen, text: "Tự động lựa chọn và chỉnh sửa cảnh quay" },
      {
        icon: FaProjectDiagram,
        text: "Ghép nối cảnh và tạo video hoàn chỉnh tự động",
      },
    ],
  },
  {
    title: "7. Âm thanh",
    icon: FaHeadphones,
    items: [
      { icon: FaVolumeUp, text: "Cải thiện âm thanh trong video" },
      { icon: FaMicrophoneAlt, text: "Loại bỏ tạp âm và tiếng ồn nền" },
      { icon: FaBullhorn, text: "Thêm hiệu ứng âm thanh sống động" },
    ],
  },
  {
    title: "8. Kỹ xảo",
    icon: FaMagic,
    items: [
      { icon: FaRobot, text: "Tạo hiệu ứng hình ảnh ấn tượng" },
      { icon: FaFilm, text: "Sáng tạo video độc đáo, thu hút" },
    ],
  },
  {
    title: "9. Voice",
    icon: FaMicrophoneAlt,
    items: [
      { icon: FaMicrophoneAlt, text: "Tạo giọng nói tự nhiên, thu hút" },
      { icon: FaBullhorn, text: "Giọng thuyết minh hấp dẫn, truyền cảm" },
      { icon: FaVolumeUp, text: "Thêm hiệu ứng âm thanh hỗ trợ" },
    ],
  },
  {
    title: "10. Sáng tạo âm nhạc",
    icon: FaMusic,
    items: [
      { icon: FaMusic, text: "Sáng tạo nhạc nền phù hợp chủ đề" },
      { icon: FaPaintBrush, text: "Phối khí và giai điệu du lịch đặc sắc" },
      { icon: FaSmile, text: "Tạo không khí âm nhạc độc đáo, ấn tượng" },
    ],
  },
];

const Banner = () => {
  return (
    <section className="banner">
      <div className="banner__overlay" />
      <div className="banner__content">
        <h1 className="banner__title">10 Kỹ năng A.I </h1>

        <div className="banner__cards">
          {cardsData.map(({ title, icon: Icon, items }, idx) => (
            <div
              key={idx}
              className="banner__card"
            >
              <h2 className="banner__card-title">
                <Icon className="banner__icon" /> {title}
              </h2>
              <ul className="banner__card-list">
                {items.map(({ icon: ItemIcon, text }, i) => (
                  <li key={i}>
                    <ItemIcon /> {text}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Banner;
